<script setup>
import { useAccountStore } from "@shared/stores/AccountStore"
import { useRouter } from "vue-router"

const accountStore = useAccountStore()
const router = useRouter()

const handleOkClick = () => {
    accountStore.setEmailVerifiedModalVisibility(false)
    router.push({ name: 'home' })
}
</script>

<template>
    <div id="divAppAlert" class="show" v-if="accountStore.isEmailVerifiedModalOpen">
        <div class="divAlertOverlay"></div>
        <div class="divAlertPopup">
            <div id="divAlertMessage">
                Your email has been verified successfully.
            </div>
            <div id="divAlertButtons">
                <button class="btnAlert" @click="handleOkClick">Ok
                </button>
            </div>
        </div>
    </div>
</template>
